export default "__VITE_ASSET__4657698a__"